import React, { useCallback, useMemo } from "react";
import * as R from "ramda";

import Chatbot, {
  selectors as chatbotSelectors,
  validators as chatbotValidators
} from "../../../../../../../components/Chatbot";

function ScreeningChatbot({ t, onError, onChange, error, option }) {
  const handleChange = useCallback(
    questions =>
      chatbotValidators.getError(null, questions, error => {
        onChange({
          config: {
            chatTree: {
              questions
            }
          },
          error
        });
      }),
    [onChange]
  );

  const config = useMemo(
    () => R.path(chatbotValidators.INITIAL_CHATBOT_VALIDATION_PATH, option),
    [option]
  );

  return (
    <Chatbot
      disableChat
      value={
        R.isEmpty(config)
          ? chatbotSelectors.getInitialValue(
              t("opportunity:process.stepTypes.chatbot.initialMessage")
            )
          : config
      }
      onChange={handleChange}
      error={error}
      validateTree={() => {
        chatbotValidators.getError(
          null,
          R.path(chatbotValidators.INITIAL_CHATBOT_VALIDATION_PATH, option),
          onError
        );
      }}
      testEnabled={false}
    />
  );
}

export default ScreeningChatbot;
